// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".FieldError-module__errorContainer___1pUIb{color:#b81237;margin-top:24px;display:flex}.FieldError-module__errorContainer___1pUIb svg{margin-right:14px;margin-top:3px}.FieldError-module__errorContainer___1pUIb div{flex:1}", ""]);
// Exports
exports.locals = {
	"errorContainer": "FieldError-module__errorContainer___1pUIb"
};
module.exports = exports;
